import { configureStore } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { catchError } from 'rxjs/operators';

// SLICES
import createAccountSlice from '../containers/createAccount/createAccountSlice';
import processCardInfoSlice from '../containers/processCardInfo/processCardInfoSlice';
import collectContactInfoSlice from '../containers/collectContactInfo/collectContactInfoSlice';

// EPICS
import processCardInfoEpics from '../containers/processCardInfo/processCardInfoEpics';
import createAccountEpic from '../containers/createAccount/createAccountEpic';
import collectContactInfoEpic from '../containers/collectContactInfo/collectContactInfoEpic';

const epicMiddleware = createEpicMiddleware();
const epics = combineEpics(
	...processCardInfoEpics,
	...createAccountEpic,
	...collectContactInfoEpic
);

const rootEpic = (action$, store$, dependencies) =>
	epics(action$, store$, dependencies).pipe(
		catchError((error, source) => {
			console.error(error);
			return source;
		})
	);

export const store = configureStore({
	reducer: {
		processCardInfoSlice,
		createAccountSlice,
		collectContactInfoSlice
	},
	middleware: [epicMiddleware]
});

epicMiddleware.run(rootEpic);
